module.exports = __webpack_public_path__ + "static/media/transfer_miles_teal.2ac950e8.svg";